import { ReactNode } from "react";
import Heading from "./Heading";

// Title + optional action button + optional breadcrumb, laid out consistently across pages.
export default function PageHeader({
  title,
  action,
  breadcrumb,
}: {
  title: ReactNode;
  action?: ReactNode;
  breadcrumb?: ReactNode;
}) {
  return (
    <div className="mb-6">
      {breadcrumb}
      <div className="flex flex-wrap items-center justify-between gap-4">
        <Heading level={2}>{title}</Heading>
        {action}
      </div>
    </div>
  );
}
